import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import logo from "../../../../src/assets/forbidden-lands/forbidden-lands-logo.webp";
import sectionDivider from "../../../../src/assets/forbidden-lands/session16_17/bitter-reach-page-banner-session-16_17.webp";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./forbidden-lands-styles.scss";

import yanti from "../../../../src/assets/forbidden-lands/session16_17/yanti.webp";
import shade from "../../../../src/assets/forbidden-lands/session16_17/hungering-shade.webp";
import legendAssare from "../../../../src/assets/forbidden-lands/legend-tiles/legend-assares-harpoon.webp";
import legendBjarke from "../../../../src/assets/forbidden-lands/legend-tiles/legend-bjarkes-warming-flagon.webp";
import harpoon from "../../../../src/assets/forbidden-lands/session16_17/assares-harpoon.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "1",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Carter One",
  backgroundColor: "rgba(0, 0, 0, 1) ",
  color: "white",
  marginBottom: "15px",
};

const FBLSession16_17 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };

  const section1Data = [
    {
      title: "Battle of the Hungering Shade (Session 16)",
      anchor: "freedom-day",
      sectionTitleCssName: "sectionTitleFBL",
      text: (
        <div className="fblBodyText">
          <ImageComponent
            image={shade}
            caption="Hungering Shade"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="The great wolfkin hunder Assare haunts an adandoned well near the Southern Range mountains, her famous spear beside her body at the bottom of the well. Her spirit rises in the form of a hungering shade."
            isLegend={false}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          At the stronghold, a band of Frostwind orcs arrives at Ruenlocke
          claiming the stronghold is on their land. Ibak and Glade grovel and
          placate to buy time. The orcs leave, promising to return after their
          next hunt.
          <br />
          <br />
          Meanwhile, back the at mysterious well in the tundra, our{" "}
          <span style={{ color: "burlywood" }}>
            party fights the black, inky form of a hungering shade
          </span>{" "}
          guarding the well.. <br />
          <br />
          The shade grapples Erollo who is terrified by the supernatural shrieks
          of the spirit. He struggles for several rounds to get free and then
          runs pell mell across the tundra in a desperate bid to escape. Lobo
          lights up the Crystalline Flask found long ago at the lighthouse of
          the winter elves in Northfall. The blue light seems to bother the
          shade and it loses a round af attack adjusting to the light. Zenith
          gets the kliling blow on the shade with what turns out to be his final
          arrow.
          <br />
          <br />
          <ImageComponent
            image={harpoon}
            caption="Assare's Harpoon"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Assare’s Harpoon is carved from a single piece of bone from an unknown monster that the Assare slew as a young adventurer. The weapon is several meters long and adorned with motifs depicting Assare's life and deeds."
            isLegend={false}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <ImageComponent
            image={legendAssare}
            caption="Legend: Assare's Harpoon"
            cssClass="imageRight"
            handleClick={handleClick}
            modalBody="The wolfkin Assare was one of the greatest heroes of the Bitter Reach and the greatest hunter to ever have sailed the cruel ocean. With her magical harpoon, she fought outlaws and Nanuiks as well as Pikebeasts, Giant Squid and Sea Serpents. She disappeared one night when the fiercest of storms raged over the ocean, on her hunt for Logrim, the monstrosity that had devoured countless ships and fishermen over the years. The harpoon disappeared with its owner, but Logrim still wreaks havoc!"
            isLegend={true}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          At the bottom of the well, the soil is moist from deep volcano
          activity under the tundra. A decaying corpse of a female wolkin hunter
          slumps against the well with an old but superier harpoon leaning
          agaist the well wall. In a pounch on the corpse is a written scroll in
          the nascent writting known as wolfkin scratch. Lobo puzzles out the
          written word of his kin and the{" "}
          <span style={{ color: "burlywood" }}>
            party thus discovers the legend of Assare's Harpoon
          </span>
          . Her vanity prompted her to carry the legend of her own prowess until
          the day she met her end in the Bitter Reach.
          <br />
          <br />
          The party continues toward the Southern Range and{" "}
          <span style={{ color: "burlywood" }}>
            stops in the small trapper camp known as Windmere
          </span>
          ; so-called because of the icy winds ripping down from the mountains.
          The camp is a small collection of tents and their occupant trappers
          and hunters. The camp has an informal spokesperson named Yanti.{" "}
          <span style={{ color: "burlywood" }}>
            Yanti is a female frailer elf with face tattoos
          </span>
          . She asks if anyone in the party is a criminal. Erollo dodges the
          question without denying it; both he and Lobo hail from Gomsten
          Island. Yanti takes an instant dislike to Zenith who is an
          elvenspring. Yanti feels the elvenspring are the soft, ass-kissing
          mongrel breed whereas frailers are tough and proud. When asked if the
          party is here to steal, Erollo announces, "
          <span style={{ color: "lightgreen" }}>
            If anything, I am here to steal your stories
          </span>
          ".
          <br />
          <br />
          The party buys some supplies including arrows. This far from Northfall
          the normal quiver of arrows is 20 copper as opposed to the standard 12
          copper. It is apparent that supply and demand begin to take a steep
          toll the closer to the glacier or mountains one travels in the Reach.
          Erollo barters with an old trapper who agrees to hear Erollo perform.
          <span style={{ color: "burlywood" }}>
            Erollo performs his newly penned Legend of One-Legged Lobo and the
            Battle of the Hungering Shade
          </span>
          . The old man loves it so much he gives Erollo his seat (a small
          shield) and a bottle of spirits without charging a thing.
          <br />
          <br />
          <small>Attendees: Erollo, Lobo, and Zenith.</small>
          <br />
          <small>Ending Datetime: 12pm, Springrise 16, 1165</small>
          <h5>XP</h5>
          <ul>
            <li>Session 1.0</li>
            <li>
              Legend: 1.0 (legend of Assare's Harpoon found written in Assare's
              corpse)
            </li>
            <li>Lore: 0.0</li>
            <li>Hex: 0.0</li>
            <li>Pride: 0.0</li>
            <li>Treasure: 0.0</li>
            <li>Monster: 1.0 (hungering shade)</li>
            <li>Dark Secret: 0.0</li>
            <li>
              <strong>TOTAL: 3.0</strong>
            </li>
          </ul>
          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];
  const section2Data = [
    {
      title: "To Catch A Thief (Session 17)",
      anchor: "freedom-day",
      sectionTitleCssName: "sectionTitleFBL",
      text: (
        <div className="fblBodyText">
          <ImageComponent
            image={yanti}
            caption="Yanti"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Yanti is a frailer half-elf trapper and hunter. She is the de facto voice of camp Windmere when she's at the camp. She is an ex-criminal that favors rogues and rough types. She loathes elvenspring and thinks they are soft, ass-kissing mongrels."
            isLegend={false}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          In Windmere, Erollo wants a helmet. Muunokhoi the trapper has a kettle
          helmet. The standard price of 5 silver is raised to 10 silver for this
          precious piece of armor this far out in the tundra. Erollo says he
          will think about it and instead performs and entertains the camp,
          singing of the Legend of the Hungering Shade; a new version of the
          tale that now features three hungering shades and Erollo besting one
          of them all on his own. He sings also of Aasare's Harpoon as Zenith
          marches around posing with the harpoon like the elevenspring version
          of Vanna White as Erollo sells the tale.{" "}
          <span style={{ color: "burlywood" }}>
            The song and performance are such a huge hit that the camp is
            cheering and Muunokhoi offers the helmet for only 6 silver
          </span>
          . Erollo gets the helmet after help from Lobo's stash of coin.
          <br />
          <br />
          Feeling the Windmere welcome, the party lingers to train. Zenith asks
          Lobo for another loan and all the spending finally gets on Lobo's
          nerves as he barks,{" "}
          <span style={{ color: "lightgreen" }}>
            "I'm getting tired of everyone asking for something hard work and
            dedication can get you for free."
          </span>
          <br />
          <br />
          As Lobo and Zenith train, Erollo works on his next epic poem. He isn't
          so much suprprised as pleased when Yanti sits to listen and fangirl as
          she drinks campmade booze. Let's just say the tale ends with Erollo
          getting some tail. Erolla is awakened the next morning by Zenith
          poking his cowled head into the tent where Erollo and Yanti lay
          cuddled under a fur. "
          <span style={{ color: "lightgreen" }}>
            Hey, uh, Erollo, can you help me look. The artifact harpoon is gone.
          </span>
          ", Zenith announces.
          <br />
          <br />
          <ImageComponent
            image={legendBjarke}
            caption="Bjarke's Warming Flagon"
            cssClass="imageRight"
            handleClick={handleClick}
            modalBody="Three hundred years ago, the dwarf Bjarke crafted a magical flagon to survive the cold nights of the wilderness of the Bitter Reach, which he wandered far and wide hunting for restless dead who longed for forgiveness and eternal rest. It is said that he fell victim to a powerful Death Knight and now wanders the frozen wastes as a restless spirit himself."
            isLegend={true}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          <span style={{ color: "burlywood" }}>
            The party scrambles to find the missing artifact harpoon
          </span>
          . Lobo locks onto the scent and tracks around he camp using his
          HUNTING INSTINCT in a homebrew manner where we allow it to give some
          to be determined benefit when tracking. Erollo and Zenith look around
          and ask around in the camp. Yanti is pissed off at the rude morning
          interruption and in the cold light of day, under the weight of
          sobriety, she seems chagrined at her hookup with Erollo and she can't
          put on her furs and skeedaddle fast enough.
          <br />
          <br />
          The party discovers fresh tracks from the late morning twilight
          heading toward he mountains, and toward the Tower of the Farseers.
          Following the tracks, the{" "}
          <span style={{ color: "burlywood" }}>
            party is ambushed by five trappers
          </span>{" "}
          that stole the harpoon. Zeninth activiates his pride that he will
          steal only from those who deserve it; having been stolen from when he
          didn't deserve it has put such a fire under his ass that his KEEP
          WATCH roll with a pride roll gains four successes!! The ambush is
          foiled and the battle begins. Lobo deals with two trappers that keep
          dodging his scimitar slashes as Zenith lights them up with his bow.
          Erollo wades in to assist prone Lobo. As the battle turns against the
          trappers, the two remaining attempt to flee. The poor soul flanked by
          Erollo and Lobo doesn't stand a chance, and Zenith races to pin down
          the trapper wielding the actual harpoon with GRAPPLE.
          <br />
          <br />
          The two thieves are kneeling in the snow. One begs for his life and
          recognizes Lobo. He hisses at him companion,
          <span style={{ color: "lightgreen" }}>
            "I told you this was Lobo. The brothers of the bitter reach, they
            are famous. I told you we shouldn't steal the harpoon "
          </span>
          . The thrief who wielded the harpoon spits out accusations that it is
          the party's own fault for advertising the harpoon and dancing around
          camp shouting out all about the precious artifact as if they wanted it
          to be stolen.
          <br />
          <br />
          Erollo plays good cop, claiming to understand their motivation; how
          after hearing his rousing tale they surely wanted to become heroes
          like Erollo and his friends; understandable. He says they can live if
          they can share information. It turns out the thieves have long lusted
          for an artifact. They share the{" "}
          <span style={{ color: "turquoise" }}>
            LEGEND OF BJARKE'S WARMING FLAGON{" "}
          </span>{" "}
          with the party.
          <br />
          <br />
          Lobo lopes over to the thieves. The one who recognized him says his
          name is <strong>Notaku</strong>. He is so sorry. Let him live and he
          will sing the praises of the brothers and Lobo the One-Legged. The
          ringleader is named <strong>Ogaleesha</strong> who growls defiantly at
          Lobo still claiming it is their fault for advertising the artifact.
          Lobo towers over Ogaleesha and says,
          <span style={{ color: "lightgreen" }}>
            " You know now of Lobo the One-Legged. And now you understand me
            Ogaleesha . . . Ogaleesha the One-Handed"
          </span>
          . With a flick of his scimitar he severs Ogaleesha's right hand.
          Ogaleesha keens wildly clutching at his stump. Notaku crawls over to
          assist his friend mumbling,{" "}
          <span style={{ color: "lightgreen" }}>
            "I told you we should not steal the harpoon."
          </span>
          <br />
          <br />
          The party travels one more hex without incident. As they climb the
          glacier base of the Southern Range mountains, their sherpa points to
          the sky. There, like a spear piercing the sky, is a huge, narrow
          tower.{" "}
          <span style={{ color: "lightgreen" }}>
            The sherpa shouts "Tukakavatik" and gestures wildly. No one in the
            party knows Ailander but they can all surmise that the sherpa is
            saying "Tower of the Farseers".
          </span>{" "}
          <br />
          <strong> Their goal is in sight!</strong>
          <br />
          <br />
          <small>Attendees: Erollo, Lobo, and Zenith.</small>
          <br />
          <small>Ending Datetime: 6pm, Springrise 18, 1165</small>
          <h5>XP</h5>
          <ul>
            <li>Session 1.0</li>
            <li>
              Legend: 1.0 (legend of Bjarke's Warming Flagon told by Notaku in
              exchange for his life after stealing Assare's Harpoon
            </li>
            <li>Lore: 0.0</li>
            <li>Hex: 1.0</li>
            <li>Pride: 1.0 (Zenith successfully avoids party ambush)</li>
            <li>Treasure: 0.0</li>
            <li>Monster: 0.0</li>
            <li>Dark Secret: 0.0</li>
            <li>
              <strong>TOTAL: 3.0 (4.0 for Zenith))</strong>
            </li>
          </ul>
          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/forbidden-lands/fbl-page-background-blizzard.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "IM Fell Great Primer",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a href="#freedom-day" name="pageTop">
                  <img
                    src={logo}
                    style={{ maxWidth: "200px" }}
                    alt="Forbidden Lands Campaign"
                  />
                </a>
              </main>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            <img src={sectionDivider} alt="section divider" />
            <Card.Body>
              <Card.Title
                id="cardTitle-forbidden-lands"
                className="cardTitle-forbidden-lands  "
              >
                Battle of the Hungering Shade, shananigans in the trapper camp
                Windmere, and dealing with harpoon thieves.
                <br />
                <br />
                <small>
                  ⇐ Session 15:{" "}
                  <a href="./forbidden-lands-session-15">
                    To the Tower, Part 2
                  </a>
                  ☠ Session 18:{" "}
                  <a href="./forbidden-lands-session-18">
                    Tower of the Farseers
                  </a>{" "}
                  ⇒{" "}
                  {/* ☠
                  Session 17:{" "}
                  <a href="./forbidden-lands-session-17">
                    TBD
                  </a>{" "}
                  ⇒{" "} */}
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
              <div>
                <ContentContainer data={section2Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default FBLSession16_17;
